import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  enabled: {
    verticalAlign: 'middle',
    animation: `${keyframes`
      from {
        opacity: 0;
        transform: translateY(-24px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    `} 0.5s ease-out 0.55s`,
    animationFillMode: 'backwards',
    color: 'rgb(0, 105, 225)',
  },
  disabled: {
    verticalAlign: 'middle',
    animation: `${keyframes`
      from {
        opacity: 0;
        transform: translateY(-24px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    `} 0.5s ease-out 0.55s`,
    animationFillMode: 'backwards',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  icon: {
    marginRight: `${theme.spacing(1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
    verticalAlign: 'middle',
  },
  statusIcon: {
    marginRight: `${theme.spacing(1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
    verticalAlign: 'middle',
  },
  editButton: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(1)} !important`,
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginTop: theme.spacing(2),
  },
}))
